(function () {
    'use strict';

    const fontSizeType = {
        min: 'min',
        normal: 'normal',
        max: 'max'
    };

    let actualFontSizeType = fontSizeType.normal;

    function setFontSize(type, setLocalStorage) {
        const size = fontSizeType[type];

        $('html').attr('data-font-size', size);

        if (setLocalStorage)
            localStorage.setItem('font-size', type);
    }

    function handleFontSize() {
        if (localStorage.getItem('font-size')) {
            actualFontSizeType = localStorage.getItem('font-size');
        }
        setFontSize(actualFontSizeType, false);

        // events
        $('.font-trigger').on('click', function (e) {
            if (actualFontSizeType === fontSizeType.normal)
                actualFontSizeType = fontSizeType.max;
            else if (actualFontSizeType === fontSizeType.max)
                actualFontSizeType = fontSizeType.min;
            else if (actualFontSizeType === fontSizeType.min)
                actualFontSizeType = fontSizeType.normal;

            setFontSize(actualFontSizeType, true);
            e.preventDefault();
            return false;
        });
    }

    function handleContrast() {
        // on start
        if (localStorage.getItem('contrast') && localStorage.getItem('contrast') === 'on') {
            $('.contrast-trigger').addClass('active');
            $('body').addClass('contrast');
        }

        // events
        $('.contrast-trigger').on('click', function (e) {
            if (localStorage.getItem('contrast') && localStorage.getItem('contrast') === 'on') {
                localStorage.setItem('contrast', 'off');
                $('.contrast-trigger').removeClass('active');
            } else {
                localStorage.setItem('contrast', 'on');
                $('.contrast-trigger').addClass('active');
            }
            $('body').toggleClass('contrast');
            e.preventDefault();
            return false;
        });
    }



    $(document).ready(function () {

        handleFontSize();
        handleContrast();

    });
}(jQuery));
